// JS se encarga de sumar o restar el valor de inputs de cantidad

js_quanty()
function js_quanty(){
    document.addEventListener('DOMContentLoaded', initQuanty)
}

function initQuanty() {
    const contents = document.querySelectorAll('.js-quanty')

    contents.forEach(content => {
        const input = content.querySelector('.js-quanty__input')
        quantyMinus(content, input)
        quantyPlus(content, input)
    })

    function quantyMinus(content, input) {
        const button = content.querySelector('.js-quanty__minus')
        button.addEventListener('click', e => {
            e.preventDefault()
            input.value = (input.value/1) - 1
            if (input.value < 1) {
                input.value = 1
            }
        })
    }

    function quantyPlus(content, input) {
        const button = content.querySelector('.js-quanty__plus')
        button.addEventListener('click', e => {
            e.preventDefault()
            input.value = (input.value/1) + 1
        })
    }
}
